export default __webpack_public_path__ + "static/media/general.6e5643d5.svg";